const asList = (value) => (Array.isArray(value) ? value : Object.values(value || {}));

export function getEventPartnerWaypointIds(event) {
  const ids = new Set();
  const addServices = (items) => {
    asList(items).forEach((item) => {
      const id = item?.partnerWaypointId || item?.waypointId || item?.partnerId;
      if (id) ids.add(String(id));
    });
  };

  addServices(event?.globalLodgings);
  addServices(event?.globalMeals);
  asList(event?.meetingPoints).forEach((day) => {
    addServices(day?.lodgings);
    addServices(day?.meals);
  });
  return ids;
}

export function isEventPartner(event, user, waypoints = []) {
  const uid = String(user?.uid || "");
  if (!uid) return false;

  const eventPartnerIds = getEventPartnerWaypointIds(event);
  if (!eventPartnerIds.size) return false;

  return asList(waypoints).some((waypoint) =>
    eventPartnerIds.has(String(waypoint?.id || "")) &&
    String(waypoint?.partnerUserUid || "") === uid
  );
}
